import { useState, useEffect } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import { useTheme } from "@mui/material/";

export function useGoogleMapsApi(apiKey) {
  const [googleApi, setGoogleApi] = useState(null);
  const [loadError, setLoadError] = useState();
  const theme = useTheme();

  useEffect(() => {
    if (googleApi) {
      return;
    }

    const loader = new Loader({
      id: "default",
      apiKey,
      language: theme.lang ?? "en",
    });

    loader
      .load()
      .then(() => {
        setGoogleApi(window.google);
      })
      .catch((error) => {
        setLoadError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiKey]);

  return [googleApi, loadError];
}
